import React from 'react';
import { Menu, MenuItem, IconButton, Typography, Box } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const SpotFilterButton = ({ label, options, value, onChange, placeholder = "Select Filter" }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenuItemClick = (selectedValue) => {
        onChange(selectedValue);
        handleClose();
    };

    const isOpen = Boolean(anchorEl);

    return (
        <Box display="flex" justifyContent="center" alignItems="center">
            
            <FilterListIcon color="secondary" />
            
            <Typography 
                variant="body1" 
                sx={{ marginRight: 1, display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                onClick={handleClick}
                pl={2}
            >
                {label}                
                {isOpen ? <ExpandLessIcon fontSize='large' sx={{pl:1}}/> : <ExpandMoreIcon fontSize='large' sx={{pl:1}}/>}
            </Typography>
            <Menu
                anchorEl={anchorEl}
                open={isOpen}
                onClose={handleClose}
            >
                {options.map((option, index) => (
                    <MenuItem
                        key={index}
                        selected={value === option.value}
                        onClick={() => handleMenuItemClick(option.value)}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

export default SpotFilterButton;
